import * as actionTypes from '../actionTypes';

export const setDivision = division => ({ type: actionTypes.divisions.SET_DIVISION, division });
export const setDivisions = ({ divisions, divisionRelations }) => ({
  type: actionTypes.divisions.SET_DIVISIONS,
  divisions,
  divisionRelations
});